module.exports = __webpack_public_path__ + "img/Avatar-12.c709a9cb.svg";